import { render, staticRenderFns } from "./admin_est_cirugia.vue?vue&type=template&id=40e74da4&"
import script from "./admin_est_cirugia.js?vue&type=script&lang=js&"
export * from "./admin_est_cirugia.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports